"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEW_TO_LABEL_MAPPING = void 0;
var _view = require("../types/view");
const VIEW_TO_LABEL_MAPPING = exports.VIEW_TO_LABEL_MAPPING = {
  [_view.EActiveView.AccountSelect]: 'accountSelect',
  [_view.EActiveView.AccountSelectError]: 'accountSelectError',
  [_view.EActiveView.Agreement]: 'agreement',
  [_view.EActiveView.AuthenticationRegistration]: 'authenticationRegistration',
  [_view.EActiveView.ConfirmPhone]: 'confirmPhone',
  [_view.EActiveView.ConfirmSelectedAccount]: 'confirmSelectedAccount',
  [_view.EActiveView.EmailSent]: 'emailSent',
  [_view.EActiveView.PhoneAuth]: 'phoneAuth',
  [_view.EActiveView.PhoneAuthValidateSms]: 'phoneAuthValidateSms',
  [_view.EActiveView.Restore]: 'restore',
  [_view.EActiveView.SocialCreate]: 'socialCreate',
  [_view.EActiveView.SocialMerge]: 'socialMerge',
  [_view.EActiveView.TokenExpiredError]: 'tokenExpiredError',
  [_view.EActiveView.TwoFactorWithPhone]: 'twoFactorWithPhone',
  [_view.EActiveView.TwoFactorPhoneValidateSms]: 'twoFactorPhoneValidateSms',
  [_view.EActiveView.TwoFactorPhoneValidateCall]: 'twoFactorPhoneValidateCall',
  [_view.EActiveView.TwoFactorAttemptsExhausted]: 'twoFactorAttemptsExhausted',
  [_view.EActiveView.TwoFactorWithEmail]: 'twoFactorWithEmail',
  [_view.EActiveView.PhoneAuthValidateCall]: 'phoneAuthValidateCall',
  [_view.EActiveView.RememberedAccountsSelect]: 'latestAccountSelect',
  [_view.EActiveView.EnterPhoneNumber]: 'enterPhoneNumber'
};